import { useState, useEffect } from 'react';

export const useResultsData = (batch_id) => {
  const [results, setResults] = useState([]);
  const [retrievalResults, setRetrievalResults] = useState(null);
  const [resultsSummary, setResultsSummary] = useState(null);
  const [isCreatingTasks, setIsCreatingTasks] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(0);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let timer;

    const fetchResults = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}results/${batch_id}`);
        if (!response.ok) throw new Error(`Error ${response.status}: ${response.statusText}`);

        const data = await response.json();
        console.log('Response:', data);

        if (data.status === 'PENDING') {
          setIsCreatingTasks(true);
          timer = setTimeout(() => setRetry((prev) => prev + 1), 5000);
          return;
        }

        if (data.status === 'IN_PROGRESS') {
          setProgress(data.progress_pct || 0);
          setIsCreatingTasks(false);
          timer = setTimeout(() => setRetry((prev) => prev + 1), 5000);
          return;
        }

        if (data.status === 'DONE') {
          setIsCreatingTasks(false);
          setLoading(false);
          const filteredResults = data.results.map((row) => ({ ...row, _originalRow: row }));
          setResults(filteredResults);
          setRetrievalResults(data.retrieval_eval_results || null);
          setResultsSummary(data.summary || batch_id);
        }

        if (data.status === 'ERROR') {
          setIsCreatingTasks(false);
          setLoading(false);
          setResults('Error');
        }
      } catch (err) {
        console.error('❌ Fetch error in useResultsData:', {
          batch_id,
          url: `${process.env.REACT_APP_BACKEND_URL}results/${batch_id}`,
          error: err,
        });
        setError(`Failed to fetch results: ${err.message}`);
        setLoading(false);
      }
    };

    fetchResults();

    return () => clearTimeout(timer);
  }, [batch_id, retry]);

  return {
    results,
    retrievalResults,
    resultsSummary,
    isCreatingTasks,
    loading,
    error,
    progress,
    retry,
    setRetry,
  };
};
